import { Box } from '@mui/material'
import { isValid, parse } from 'date-fns/esm'

import { EligibilityPickerFieldWrapper } from './components/EligibilityPickerField'
import { EligibilityVisibilityHandler } from './components/EligibilityVisibilityHandler'

import * as OrderTexts from '../../../../../../../../../intl'
import { form } from '../../../../../../formState'
import { OrderFormValues } from '../../../../../../typings'
import { Props } from './../../../../typings'

export function Eligibility(props: Props) {
  const { isSimulation } = props

  form.useAddFieldValidation('order.eligibility', (field, _formApi) => {
    if (field.value) {
      const eligibility = field.value

      switch (eligibility.type) {
        case 'by':
          if (!isValid(parse(eligibility.date, 'yyyyMMdd', new Date()))) {
            return OrderTexts.getValidationErrorEligibilityDateText()
          }
          break

        case 'on':
          if (eligibility.dates.length === 0) {
            return OrderTexts.getValidationErrorEligibilityDatesText()
          }
          break
      }
    }
  })

  return (
    <EligibilityVisibilityHandler
      isSimulation={isSimulation}
      recurrenceSettingsFieldName="recurrenceSettings"
    >
      <Box sx={{ mt: 3, width: '100%' }}>
        <EligibilityPickerFieldWrapper<'order.eligibility', OrderFormValues>
          name="order.eligibility"
          eligibilityPickerFieldProps={{
            testId: 'order-eligibility',
            label: OrderTexts.geFieldLabelEligibilityText(),
          }}
        />
      </Box>
    </EligibilityVisibilityHandler>
  )
}
